import bus from "../bus";
import { playerEvents } from "../player/events";

let savedCurrentTime = 0;
let savedDuration = 0;

export default function initMediaSession() {
  if ("mediaSession" in navigator) {
    bus.on(playerEvents.STATUS_CHANGE, onStatusChange);
    bus.on(playerEvents.TIME_UPDATE, onTimeUpdate);
  }
}

function onStatusChange({
  currentItemTitle,
  currentItemSubtitle,
  currentTargetType,
  target
}) {
  navigator.mediaSession.metadata = new window.MediaMetadata({
    title: currentItemTitle,
    artist: currentTargetType === "stream" ? "On air" : currentItemSubtitle,
    artwork: [
      { src: require("./playing-96.jpg"), sizes: "96x96", type: "image/jpg" },
      {
        src: require("./playing-128.jpg"),
        sizes: "128x128",
        type: "image/jpg"
      },
      {
        src: require("./playing-192.jpg"),
        sizes: "192x192",
        type: "image/jpg"
      },
      {
        src: require("./playing-256.jpg"),
        sizes: "256x256",
        type: "image/jpg"
      },
      {
        src: require("./playing-384.jpg"),
        sizes: "384x384",
        type: "image/jpg"
      },
      { src: require("./playing-512.jpg"), sizes: "512x512", type: "image/jpg" }
    ]
  });

  // Allow seeking 10s at a time
  if (currentTargetType !== "stream") {
    navigator.mediaSession.setActionHandler("seekbackward", () => {
      const seekTime = Math.max(savedCurrentTime - 10, 0);
      bus.emit(playerEvents.SEEK_TO, seekTime);
    });
    navigator.mediaSession.setActionHandler("seekforward", () => {
      const seekTime = Math.min(savedCurrentTime + 10, savedDuration);
      bus.emit(playerEvents.SEEK_TO, seekTime);
    });
  } else {
    navigator.mediaSession.setActionHandler("seekbackward", null);
    navigator.mediaSession.setActionHandler("seekforward", null);
  }

  // Handle next/prev
  if (target && target.canPlayPrev()) {
    navigator.mediaSession.setActionHandler(
      "previoustrack",
      target.prev.bind(target)
    );
  } else {
    navigator.mediaSession.setActionHandler("previoustrack", null);
  }
  if (target && target.canPlayNext()) {
    navigator.mediaSession.setActionHandler(
      "nexttrack",
      target.next.bind(target)
    );
  } else {
    navigator.mediaSession.setActionHandler("nexttrack", null);
  }
}

function onTimeUpdate({ currentTime, duration }) {
  savedCurrentTime = currentTime;
  savedDuration = duration;
}
